const { select, remToPx } = require('./../../../_global/js/utility/utils');
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);



const checkIfMobile = () => {
  return window.innerWidth >= 1200 ? false : true
}



let mainLogo,
    logo,
    isMobile = checkIfMobile(),
    trackLogo = false;



const handleLogoScroll = () => {
  if (trackLogo === false) {
    mainLogo.setAttribute('data-version', 'default');
    mainLogo.querySelector('.logo').classList.remove('logo--white');
  } else {
    if (window.pageYOffset < window.innerHeight) {
      mainLogo.classList.remove('is-sticky');
    }

    // don't change the logo color if the nav is open
    // if (mainNav.classList.contains('open')) return;

    // if the logo is halfway at the bottom of the opening (1 viewport) remove the white class
    if (mainLogo.getBoundingClientRect().top >= ((window.innerHeight - (mainLogo.offsetHeight / 2)) - window.pageYOffset)) {
      mainLogo.setAttribute('data-version', 'default');
      mainLogo.querySelector('.logo').classList.remove('logo--white');
      mainLogo.querySelector('.logo').setAttribute('data-color', 'default');
    } else {
      mainLogo.setAttribute('data-version', 'white');
      mainLogo.querySelector('.logo').classList.add('logo--white');
      mainLogo.querySelector('.logo').setAttribute('data-color', 'white');
    }
  }
}



const enableLogo = (color) => {
  trackLogo = true;

  logo.setAttribute('data-color', color);

  let previousScrollTrigger = ScrollTrigger.getById('mainLogoTrigger');
  if (previousScrollTrigger) {
    ScrollTrigger.getById('mainLogoTrigger').kill(true);
    gsap.set(mainLogo, {clearProps: true});
  }

  if (window.innerWidth >= 1650) {
    gsap.set(mainLogo, {
      y: (window.innerHeight - mainLogo.offsetHeight) - remToPx(3.75)
    });
    // mainLogo scrollTrigger
    gsap.to(mainLogo, {
      y: remToPx(3.75),
      ease: 'none',
      scrollTrigger: {
        id: 'mainLogoTrigger',
        trigger: 'body',
        scrub: true,
        // markers: true,
        start: 'top top',
        end: `${window.innerHeight}px top`
      },
      onComplete: () => {
        mainLogo.classList.add('is-sticky');
      }
    });
  }

  window.addEventListener('scroll', handleLogoScroll, true);
}



const disableLogo = () => {
  trackLogo = false;

  let previousScrollTrigger = ScrollTrigger.getById('mainLogoTrigger');
  if (previousScrollTrigger) {
    console.log('found previous scroll trigger kill it!');
    ScrollTrigger.getById('mainLogoTrigger').kill(true);
    gsap.set(mainLogo, {clearProps: true});
  }
}



const resetLogo = () => {
  console.log('reset logo');
  logo.setAttribute('data-color', '');
}



const initLogo = () => {
  console.log('init logo');

  mainLogo = select('.main-logo');
  logo = select('.logo', mainLogo);

  console.log('mainLogo', mainLogo);
  console.log('logo', logo);

  window.addEventListener('resize', () => {
    isMobile = checkIfMobile();
  });
}



/* move logo */
const moveLogoToTop = () => {
  if (!mainLogo.classList.contains('sticky')) {
    // store the current y position for later use
    let currentTop = mainLogo.getBoundingClientRect().top;
    mainLogo.setAttribute('data-top', currentTop);

    gsap.to(mainLogo, {
      y: `${window.innerWidth >= 1200 ? remToPx(3.75) : remToPx(1.25)}px`,
      x: window.innerWidth >= 1200 ? -17 : 0,
      duration: .8,
      ease: 'power3.inOut'
    });
  }
}



const moveLogoBackToPrevPosition = () => {
  if (!mainLogo.classList.contains('sticky')) {
    gsap.to(mainLogo, {
      y: `${mainLogo.getAttribute('data-top')}px`,
      x: 0,
      duration: .8,
      ease: 'power3.inOut',
    });
  }
}


export { enableLogo, disableLogo, resetLogo, initLogo, moveLogoToTop, moveLogoBackToPrevPosition };
